import { render } from "./FavoriteViewsSaveForm.vue?vue&type=template&id=6753cbb3&ts=true"
import script from "./FavoriteViewsSaveForm.vue?vue&type=script&lang=ts"
export * from "./FavoriteViewsSaveForm.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Build\\TCF\\ABBp_PIS\\6.14\\PisNextGenExtProd-PisApp_6_14_0\\PisNextGenExtProd\\PisNextGen\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__